import {guid} from "@core/Util/guid";
import {resolveOperatorByName} from "@modules/JourneyBuilder/Bricks/Checkpoints/checkpoint-operator-definitions";

function inflate(deflatedConditions){
    if(!deflatedConditions){
        return [];
    }
    
    return deflatedConditions.map(x => ({
        id: guid(),
        children: x.map(y => ({
            id: guid(),
            ...y
        }))
    }));
}

function deflate(inflatedConditions){
    if(!inflatedConditions){
        return [];
    }
    
    return inflatedConditions.map(
        x => x.children.map(y => ({ 
            field: y.field, 
            
            //Ensure a value is present by always invoking `resolve` on our operator
            operator: resolveOperatorByName(y.operator).name, 
            value: y.value 
        }))
    );
}

function inflateGenericFilters(deflatedGenericConditions){
    if(!deflatedGenericConditions){
        return [];
    }

    return deflatedGenericConditions.map(filterGroup => {
        const children = filterGroup.conditions.map(filter => ({
            //Take previous cycle UI key/define new UI key
            id: filter._filterId || guid(),
            
            field: filter.field,
            operator: filter.operator,
            value: filter.id
        }));
        
        return {
            children,
            id: filterGroup.id
        }
    })
}

function deflateGenericFilters(inflatedGenericConditions){
    if(!inflatedGenericConditions){
        return [];
    }
    
    return inflatedGenericConditions.map(filterGroup => {
        const conditions = filterGroup.children.map(filter => {
            const deflatedFilter = {
                field: filter.field,
                
                //Ensure a value is present by always invoking `resolve` on our operator
                operator: resolveOperatorByName(filter.operator).name,
                id: filter.value
            };
            
            //Define UI key
            Object.defineProperty(deflatedFilter, '_filterId', {
                value: filter.id,
                enumerable: false //Don't include UI key when serializing
            });
            
            return deflatedFilter;
        });
        
        return {
            conditions,
            id: filterGroup.id
        }
    });
}

export default {
    inflate,
    deflate,

    deflateGenericFilters,
    inflateGenericFilters
}